import { SxProps, Theme } from '@mui/material';

export const progressComponentStyles = {
  container: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    paddingTop: 25,
  }) as SxProps<Theme>,

  progress: () => ({
    width: 80,
    height: 80,
  }) as SxProps<Theme>,

  text: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }) as SxProps<Theme>,
};

export default progressComponentStyles;
